export type { SiteProfile, FleetEntry, DocCategory, DocParam, GuideSection, SimScenarioPreset } from './types';
export { wognumProfile } from './wognum';
export { demoProfile } from './demo';

import type { SiteProfile } from './types';
import { wognumProfile } from './wognum';
import { demoProfile } from './demo';

export const PROFILES: Record<string, SiteProfile> = {
  wognum: wognumProfile,
  demo: demoProfile,
};

export const PROFILE_LIST = Object.values(PROFILES);
